export default {
  'memberArea.title': 'บัญชีผู้ใช้',
  'memberArea.to_next_level': 'ระยะห่างจากระดับถัดไป',
  'memberArea.member_info': 'ข้อมูลสมาชิก',
  'memberArea.invoice_carrier': 'อุปกรณ์รับใบกำกับภาษี',
  'memberArea.language': 'ภาษา',
} as Record<string, string>;
